import * as imageConversion from 'lib-image-conversion'
import { Photo } from '../models/types'

type CompressionOptions = {
  quality: number
  width: number
  type: string
}

const optionDefaults = {
  quality: 0.8,
  width: 2000,
  type: 'image/jpeg',
}

declare const window

/**
 * Utility function to compress an image file using
 * the image-conversion package from WangYuLue
 *
 * @param imageFile The File from a file input field
 * @param returnType "file" or "blob"
 * @param options Object defining options for quality, width, and type
 */
export const compressImage = async (
  imageFile: File,
  options: CompressionOptions = optionDefaults
) => {
  const res = await imageConversion.compress(imageFile, options)

  const urlCreator = window.URL || window.webkitURL
  const image = urlCreator.createObjectURL(res)

  const name = imageFile.name

  const response: Photo = {
    file: blobToFile(res, name),
    blob: image as Blob,
  }

  return response
}

const blobToFile = (theBlob: Blob, fileName: string): File => {
  const b: any = theBlob
  b.lastModifiedDate = new Date()
  b.name = fileName

  // Cast to a File() type
  return theBlob as File
}
